//libs
import React, { memo, useEffect } from 'react';

//styles
import { Container, Image, Title, SubTitle, Button } from './styles';

//defs
import { ErrorDetails } from 'shared/layouts/Listing/ErrorWrapperV2/types';

// helpers
import { onPageLoad } from './analytics';

export interface ErrorComponentProps {
  errorDetails: ErrorDetails;
  onButtonClick?: VoidFunction;
}

const IMG_ALT_TEXT = 'Error Image';

function ErrorComponent({ errorDetails, onButtonClick }: ErrorComponentProps) {
  const { title, subtitle, buttonText, imgSrc, errorMessage } = errorDetails;

  useEffect(() => {
    onPageLoad();
  }, [errorMessage]);

  return (
    <Container>
      <Image src={imgSrc} alt={IMG_ALT_TEXT} />
      <Title>{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
      {buttonText && (
        <Button kind="primary" shape="default" size="small" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </Container>
  );
}

export default memo(ErrorComponent);
